/*eslint-disable*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import "./helper";
import "./components";
import { initNotifications } from "./config/firebase";
import "sweetalert2/dist/sweetalert2.min.css";
import LottiePlayer from "@lottiefiles/lottie-player";

function showStartupError (err) {
  const el = document.getElementById("app");
  if (!el) return;
  const msg = (err && (err.message || err.toString())) || "Unknown error";
  const stack = (err && err.stack) || "";
  el.innerHTML =
    "<div style=\"padding:24px;font-family:sans-serif;max-width:600px;margin:0 auto\">" +
    "<h2 style=\"color:#c00\">Application failed to start</h2>" +
    "<pre style=\"background:#f5f5f5;padding:12px;overflow:auto;font-size:12px\">" +
    (msg + "\n\n" + stack).replace(/</g, "&lt;").replace(/>/g, "&gt;") +
    "</pre></div>";
}

try {
  Vue.component("lottiePlayer", LottiePlayer);
  Vue.config.productionTip = false;
  Vue.config.errorHandler = function (err, vm, info) {
    console.error(err, info);
    showStartupError(err);
  };
  Vue.prototype.$messaging = null;

  const vm = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");

  window.vm = vm;

  initNotifications()
    .then((m) => {
      Vue.prototype.$messaging = m || null;
      if (m && window.vm && typeof window.vm.startListeners === "function") {
        window.vm.startListeners();
      }
    })
    .catch((e) => {
      console.warn("Firebase messaging init failed:", e);
      Vue.prototype.$messaging = null;
    });
} catch (err) {
  showStartupError(err);
  throw err;
}
